import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

function formatCellValue(value) {
  if (value == null || value === '') {
    return '—';
  }
  return String(value);
}

const RecentConsumablesModal = ({
  open,
  onClose,
  consumables = [],
  loading = false,
  translations = {},
}) => {
  const emptyMessage =
    translations.noRecentConsumables ||
    'No recent consumable orders available for this retailer.';

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogTitle sx={{ fontFamily: 'BrightstarSans-Bold' }}>
        {translations.recentOrders || 'Recent Consumable Orders'}
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, minHeight: 200 }}>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              py: 6,
            }}
          >
            <CircularProgress size={32} sx={{ color: 'var(--reach-blue)' }} />
          </Box>
        ) : !consumables.length ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              py: 6,
              px: 2,
            }}
          >
            <Typography
              variant='body2'
              color='text.secondary'
              sx={{ textAlign: 'center' }}
            >
              {emptyMessage}
            </Typography>
          </Box>
        ) : (
          <TableContainer>
            <Table size='small' aria-label='recent consumable orders'>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: 'rgba(5, 10, 48, 0.04)',
                    '& .MuiTableCell-head': {
                      fontFamily: 'BrightstarSans-Bold',
                      color: 'var(--reach-blue)',
                      borderBottomColor: 'rgba(5, 5, 51, 0.1)',
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <TableCell>Submission Time</TableCell>
                  <TableCell>Form Name</TableCell>
                  <TableCell>Origin</TableCell>
                  <TableCell>Submitter</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {consumables.map((item, index) => (
                  <TableRow
                    key={item.id ?? `consumable-${index}`}
                    sx={{
                      '&:last-child td': { borderBottom: 0 },
                      '& .MuiTableCell-root': {
                        fontFamily: 'BrightstarSans-Regular',
                        color: 'var(--reach-blue)',
                        borderBottomColor: 'rgba(5, 5, 51, 0.1)',
                      },
                    }}
                  >
                    <TableCell>
                      {formatCellValue(item.submissionTime)}
                    </TableCell>
                    <TableCell sx={{ fontFamily: 'BrightstarSans-Bold' }}>
                      {formatCellValue(item.formName)}
                    </TableCell>
                    <TableCell>{formatCellValue(item.origin)}</TableCell>
                    <TableCell>{formatCellValue(item.submitter)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{translations.close || 'Close'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecentConsumablesModal;
